import { render, staticRenderFns } from "./InsuranceObjectChanger.vue?vue&type=template&id=3c4011ea&"
import script from "./InsuranceObjectChanger.vue?vue&type=script&lang=js&"
export * from "./InsuranceObjectChanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports